
import { Vue, Component } from "vue-property-decorator";
import Score from "@/components/feedback/components/Score.vue";
import { UFFeedback } from "@/utils/literals/feedback";
import { FeedbackType } from "@/schemas/Enums";
import { mapState } from "vuex";

@Component({
  components: { Score },
  computed: {
    ...mapState("session", ["session"]),
  },
})
export default class Examples extends Vue {
  exampleGroupScore = 70;
  ex1Scores = [
    {
      user: "User1",
      score: 32,
    },
    {
      user: "User2",
      score: 50,
    },
    {
      user: "User3",
      score: 65,
    },
    {
      user: "User4",
      score: 40,
    },
    {
      user: "User5",
      score: 12,
    },
  ];
  ex2Scores = [
    {
      user: "User1",
      score: 32,
    },
    {
      user: "User2",
      score: 50,
    },
    {
      user: "User3",
      score: 65,
    },
    {
      user: "User4",
      score: 40,
    },
    {
      user: "User5",
      score: 96,
    },
  ];

  getUFFb(key: string): string {
    return UFFeedback[key] || "";
  }

  // La fonction d'après sert a savoir si c'est le vieux FB ou le nouveau en moyenne, et atm on force que ce soit toujours en moyenne, pour tout le monde, même si la BDD dit le contraire
  get displayAvgFeedback(): boolean {
    // if (this.session.setting) {
    //   let settings = this.session.setting.feedback_details.find(
    //     (setting: {
    //       type: FeedbackType;
    //       display_feedback_message: boolean;
    //       display_score?: boolean;
    //       display_indiv_scores?: boolean;
    //       display_group_score?: boolean;
    //       display_avg_feedback?: boolean;
    //     }) => setting.type === FeedbackType.Performance
    //   );
    //   return settings ? settings.display_avg_feedback : false;
    // }
    // return false;
    return true;
  }
}
